import { render, staticRenderFns } from "./Paypal-Checkout.vue?vue&type=template&id=479b810d"
import script from "./Paypal-Checkout.vue?vue&type=script&lang=js"
export * from "./Paypal-Checkout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports